export class WorkTitleModel {
  public miloCode: string;
  public completeTitle: string;
  public titleVO: string;
  public title: string;
  public yearOfProduction: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: WorkTitleModel[] = [];
    jsons.forEach(json => {
      refs.push(new WorkTitleModel().fromJSON(json));
    });
    return refs;
  }
}
